import { FolderIcon } from '../../../icons/Folder/index.js'
import './index.scss'
export function ColoredFolderIcon() {
  return <FolderIcon className="colored-folder-icon" />
}
